module.exports = "/virtual-football-league/img/amblems/left/logos/Everton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Everton.png
// module id = 2068
// module chunks = 4